import clone from 'clone'
import { initialState } from '../index'
import { AGENCY_INIT_LOADING, AGENCY_INIT_SUCCESS, AGENCY_INIT_FAIL, AGENCY_QUOTESETTINGS_INIT_LOADING, AGENCY_QUOTESETTINGS_INIT_SUCCESS, AGENCY_QUOTESETTINGS_INIT_FAIL, AGENCY_QUOTATION_RESET, AGENCY_QUOTATION_INIT_LOADING, AGENCY_QUOTATION_INIT_SUCCESS, AGENCY_QUOTATION_INIT_FAIL } from '@/store/types'

export const init = {
  [AGENCY_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [AGENCY_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [AGENCY_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [AGENCY_QUOTESETTINGS_INIT_LOADING](state) {
    state.quotationSettings.init = 0
    state.quotationSettings.initErr = []
    state.quotationSettings.menu = {}
  },
  [AGENCY_QUOTESETTINGS_INIT_SUCCESS](state, data) {
    state.quotationSettings.init = 1
    state.quotationSettings.initErr = []
    state.quotationSettings.menu = data.menu
    const interList = data.intermediaryList
    interList.map(intermediary => {
      intermediary.label = intermediary.value + ' - ' + intermediary.label
    })
    state.quotationSettings.intermediaries = interList
    state.quotationSettings.isStaff = data.isStaff
  },
  [AGENCY_QUOTESETTINGS_INIT_FAIL](state, error) {
    state.quotationSettings.init = 2
    state.quotationSettings.initErr = error
    state.quotationSettings.menu = {}
  },
  [AGENCY_QUOTATION_RESET](state) {
    state.quotation = clone(initialState.quotation)
  },
  [AGENCY_QUOTATION_INIT_LOADING](state) {
    state.quotation.init = 0
    state.quotation.menu = {}
  },
  [AGENCY_QUOTATION_INIT_SUCCESS](state, data) {
    state.quotation.init = 1
    state.quotation.menu = data.menu
  },
  [AGENCY_QUOTATION_INIT_FAIL](state, data) {
    state.quotation.init = 2
    state.quotation.menu = {}
  }
}
